import * as React from "react";
import { Theme, createStyles } from '@mui/material/styles';
import { WithStyles, withStyles } from '@mui/styles';
import idssStyle from "../../Configuration/SharedStyling";
import { connect } from "react-redux";
import {
    IGenericUserProps,
    genericMapStateToProps,
} from "../../DataClasses/GenericUser";
import { IVendor, IVendorMeasure, IVendorSubOrgMapping } from "../../DataClasses/VendorMeasure";
import { Redirect } from "react-router-dom";
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid2 as Grid, IconButton, Link, Paper, Tooltip, Typography } from "@mui/material";
import request from "superagent";
import { v4 as uuidv4 } from "uuid";
import AdministrationService from "../Services/AdministrationService";
import SharedMaterialReactTable, { ISharedTableColumn } from "../Shared/MaterialReactTable";
import { lastValueFrom, firstValueFrom } from 'rxjs';
import GetAppIcon from '@mui/icons-material/GetApp';
import saveAs from 'file-saver';
import { InfoOutlined } from "@mui/icons-material";

const styles = (theme: Theme) => createStyles({
    ...idssStyle(theme),
    paperStyle: {
        flexGrow: 1,
        padding: theme.spacing(2, 2),
    }
});

interface LocalProps {
    productYear: number
}

interface IVendorMeasureGuidListStateStore {
    payload: IVendorMeasure[];
    isLoading: boolean;
    redirect: boolean;
    inputFileKey: string;
    fileTypeValid: boolean;
    isUploading: boolean;
    selectedFile?: File;
    validationTxt: string;
    transactionId: string;
    isClearingCache: boolean;
    vendorSubOrgList: IVendorSubOrgMapping[];
    showVendorMapping: boolean;
    uploadValidationMsg: string;
    openReadMe: boolean;
}

type Props = LocalProps & WithStyles<typeof styles>;

class VendorMeasureGuidListView extends React.Component<
    IGenericUserProps & Props,
    IVendorMeasureGuidListStateStore
> {
    constructor(props: any) {
        super(props);
        this.state = {
            payload: [],
            isLoading: true,
            redirect: false,
            inputFileKey: "inputKey",
            fileTypeValid: false,
            isUploading: false,
            validationTxt: "",
            transactionId: "",
            isClearingCache: false,
            vendorSubOrgList: [],
            showVendorMapping: false,
            uploadValidationMsg: "",
            openReadMe: false
        }
    }

    public async componentDidMount() {
        await this.RefreshModel();
    }

    private redirectToErrorPage() {
        return <Redirect to='/errorpage' />;
    }
    private getVendorsTableData() {
        if (this.state.showVendorMapping === true) {
            return this.state.vendorSubOrgList
        }
        let retval: IVendor[] = [];
        for (const m of this.state.vendorSubOrgList) {
            if (!retval.some(x => x.vendorOrgId === m.vendorOrgId)) {
                retval.push({ vendorOrgId: m.vendorOrgId, vendorName: m.vendorName } as IVendor)
            }
        }
        return retval;
    }

    private getVendorsTableColumns = (): ISharedTableColumn<any>[] => {
        let columns: ISharedTableColumn<any>[] = [
            {
                accessorKey: 'vendorOrgId',
                header: 'VENDOR_Id',
                enableSorting: true,
                enableFiltering: true,
                size: 120
            },
            {
                accessorKey: 'vendorName',
                header: 'VENDOR_NAME',
                enableSorting: true,
                enableFiltering: true,
                size: 200
            }
        ];

        if (this.state.showVendorMapping) {
            columns.push(
                {
                    accessorKey: 'submissionId',
                    header: 'SubmissionId',
                    enableSorting: true,
                    enableFiltering: false,
                    size: 120,
                    Cell: ({ row }) => this.submissionIdBodyTemplate(row.original)
                },
                {
                    accessorKey: 'productLine',
                    header: 'ProductLine',
                    enableSorting: true,
                    enableFiltering: true,
                    size: 120
                },
                {
                    accessorKey: 'reportingProduct',
                    header: 'ReportingProduct',
                    enableSorting: true,
                    enableFiltering: true,
                    size: 150
                },
                {
                    accessorKey: 'orgId',
                    header: 'OrgId',
                    enableSorting: true,
                    enableFiltering: true,
                    size: 100
                },
                {
                    accessorKey: 'orgName',
                    header: 'OrgName',
                    enableSorting: true,
                    enableFiltering: true,
                    size: 200
                }
            );
        }

        return columns;
    };

    private getVendorMeasuresTableColumns = (): ISharedTableColumn<any>[] => [
        {
            accessorKey: 'vendorName',
            header: 'VENDOR_NAME',
            enableSorting: true,
            enableFiltering: true,
            size: 200
        },
        {
            accessorKey: 'measureCode',
            header: 'MEASURE_ID',
            enableSorting: true,
            enableFiltering: true,
            size: 120
        },
        {
            accessorKey: 'productLine',
            header: 'PRODUCT_LINE',
            enableSorting: true,
            enableFiltering: true,
            size: 120
        },
        {
            accessorKey: 'measureGuid',
            header: 'GUID',
            enableSorting: true,
            enableFiltering: true,
            size: 250
        },
        {
            accessorKey: 'importedBy',
            header: 'ImportedBy',
            enableSorting: true,
            enableFiltering: false,
            size: 150
        },
        {
            accessorKey: 'importedOn',
            header: 'ImportedOn',
            enableSorting: true,
            enableFiltering: false,
            size: 120
        }
    ];

    private submissionIdBodyTemplate = (rowData: any) => {
        return (
            <a href={'/submissionHome/' + rowData.submissionId + "/DST/" + rowData.productLine}>
                {rowData.submissionId}
            </a>
        );
    };

    public render() {
        if (this.state.redirect) {
            return this.redirectToErrorPage();
        }
        const { classes } = this.props;

        return (
            <Paper className={classes.paperStyle}>
                <Typography className={classes.primaryBlue}>
                    Vendor Measures  (Current Product Year: {this.props.productYear})
                </Typography>
                <Grid container spacing={0}>
                    <Grid size={12}>
                        <span className="btn btn-info">
                            <input
                                type="file"
                                name="file"
                                key={this.state.inputFileKey}
                                onChange={(e) => this.handleUploadFileChange(e)}
                            />
                        </span>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <span>
                            <button
                                className="btn btn-primary"
                                disabled={
                                    !this.state.fileTypeValid || this.state.isUploading
                                }
                                onClick={async () =>
                                    await this.uploadVendorMeasureFile(this.state.selectedFile)
                                }
                            >
                                {this.state.isUploading ? "Uploading..." : "Upload"}
                            </button>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <Link
                                component="button"
                                onClick={this.handelLoadVendorList}
                            >
                                View/Download Vendor List
                            </Link>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <Link
                                component="button"
                                onClick={this.handleClearVendorMeasureCache}
                                disabled={this.state.isClearingCache}
                            >
                                {this.state.isClearingCache ? "Clearing Cache..." : "Clear Vendor Measures Cache"}
                            </Link>
                            <Dialog open={this.state.vendorSubOrgList && this.state.vendorSubOrgList.length > 0} onClose={this.clearVendorSubOrgList} classes={{ paper: classes.dialogL }} >
                                <DialogTitle id="max-width-dialog-title">
                                    <Grid container spacing={1}>
                                        <Grid size={6}>
                                            <Typography variant='h6' color='primary' className={classes.tabTitle}>
                                                Vendor List
                                                <Tooltip title="How does this page work?">
                                                    <IconButton onClick={() => this.setState({ openReadMe: true })}>
                                                        <InfoOutlined />
                                                    </IconButton>
                                                </Tooltip>
                                            </Typography>
                                            <Dialog
                                                open={this.state.openReadMe}
                                                onClose={() => this.setState({ openReadMe: false })}
                                                aria-describedby="alert-dialog-slide-description"
                                            >
                                                <DialogTitle>{"How does this page work?"}</DialogTitle>
                                                <DialogContent>
                                                    <DialogContentText id="alert-dialog-slide-description">
                                                        This page provides a list of VendorId and VendorName that have associations with submissions for the current Measurement Year.<br /><br />
                                                        By selecting "Show Vendor Org/Submission Mapping", the list will extend to include detailed information about which submissions are associated with which vendors.<br /><br />
                                                        If the VendorId assigned to the submission does not have an OrgName present in NCQADW, the row will be <span style={{ backgroundColor: 'yellow' }}>highlighted in yellow</span>.<br /><br />
                                                        If the vendor does not have any uploaded MeasureGUID associations, the row will be <span style={{ backgroundColor: '#ffcccc' }}>highlighted in red</span>.
                                                    </DialogContentText>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={() => this.setState({ openReadMe: false })}>CLOSE</Button>
                                                </DialogActions>
                                            </Dialog>
                                        </Grid>
                                        <Grid size={6}>
                                            <Checkbox
                                                checked={this.state.showVendorMapping}
                                                onChange={this.toggleVendorMapping}
                                                color="primary"
                                            />
                                            <small>Show Vendor Org/Submission Mapping</small>
                                        </Grid>
                                    </Grid>
                                </DialogTitle>
                                <Divider />
                                <DialogContent>
                                    <SharedMaterialReactTable
                                        data={this.getVendorsTableData()}
                                        columns={this.getVendorsTableColumns()}
                                        title=""
                                        isLoading={false}
                                        enablePagination={true}
                                        enableSorting={true}
                                        enableFiltering={true}
                                        enableColumnActions={true}
                                        enableRowActions={false}
                                        initialState={{
                                            pagination: { pageIndex: 0, pageSize: 10 },
                                        }}
                                        muiPaginationProps={{
                                            rowsPerPageOptions: [10, 25, 50, 100],
                                        }}
                                        emptyMessage="No vendors found."
                                    />
                                </DialogContent>
                                <Divider />
                                <DialogActions>
                                    <Button
                                        onClick={this.clearVendorSubOrgList}
                                    >
                                        ClOSE
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </span>
                        <br />
                        <label className="text-muted">
                            * .csv file contain columns: VENDOR_Name, MEASURE_ID, PRODUCT_LINE and GUID. New upload will overwrite the existing set.
                        </label>
                        {this.state.isLoading ? (
                            <div style={{ height: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Typography>Loading...</Typography>
                            </div>
                        ) : (
                            <SharedMaterialReactTable
                                data={this.state.payload}
                                columns={this.getVendorMeasuresTableColumns()}
                                title="Vendor Measures In Database"
                                isLoading={this.state.isLoading}
                                enablePagination={true}
                                enableSorting={true}
                                enableFiltering={true}
                                enableColumnActions={true}
                                enableRowActions={false}
                                initialState={{
                                    pagination: { pageIndex: 0, pageSize: 10 },
                                }}
                                muiPaginationProps={{
                                    rowsPerPageOptions: [10, 25, 50, 100],
                                }}
                                emptyMessage="No vendor measures found."
                            />
                        )}
                    </Grid>
                </Grid>
                {this.renderUploadValidation()}
            </Paper>
        );
    }

    private renderUploadValidation() {
        return (<>
            <Dialog open={this.state.uploadValidationMsg.length > 0}>
                <DialogTitle id="max-width-dialog-title">
                    Upload Response
                    <Tooltip title="Download as .txt" aria-label="Download">
                        <IconButton size='medium' aria-label="Download" onClick={() => this.downloadValidationResult(this.state.uploadValidationMsg)} hidden={this.state.uploadValidationMsg.length === 0}>
                            <GetAppIcon fontSize="inherit"></GetAppIcon>
                        </IconButton >
                    </Tooltip>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <div style={{ whiteSpace: 'pre-wrap' }}>
                        {this.state.uploadValidationMsg}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.setState({ uploadValidationMsg: "" })}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>);
    }
    private downloadValidationResult(msg: string) {
        const fileName = "VendorMeasureUploadValidation_" + new Date().toLocaleString() + ".txt";
        if (msg && msg.length > 0) {
            saveAs(new Blob([msg], {
                type: "text/plain"
            }), fileName);
        }
    }
    clearVendorSubOrgList = () => {
        this.setState({ vendorSubOrgList: [] });
    };
    toggleVendorMapping = () => {
        this.setState(
            {
                showVendorMapping: !this.state.showVendorMapping
            });
    };
    handleClearVendorMeasureCache = async () => {
        await this.clearVendorMeasureCache();
    };
    handelLoadVendorList = () => {
        this.LoadVendorList();
    }
    private async LoadVendorList() {
        const vl$ = AdministrationService.GetSoftwareVendorList$(this.props.user, this.props.productYear);
        const vl = await lastValueFrom(vl$);
        this.setState({ vendorSubOrgList: vl });
    }
    private async clearVendorMeasureCache() {
        this.setState({ isClearingCache: true });
        await firstValueFrom(AdministrationService.ClearVendorMeasureCache$(this.props.user));
        alert("Vendor measure cache cleared!");
        this.setState({ isClearingCache: false });
    }
    private async uploadVendorMeasureFile(file: File) {
        this.setState({ isUploading: true });
        const localTransactionId = uuidv4();
        this.setState({ transactionId: localTransactionId });
        var apiBaseUrl =
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL +
            "/api/administration/uploadvendormeasures";
        const data = new FormData();
        data.append("File", file, file.name);
        const req = request.post(apiBaseUrl);
        req.set({ Authorization: "Bearer " + this.props.user.access_token });
        req.send(data).end(async (err: any, res: any) => {
            if (err) {
                this.setState({ uploadValidationMsg: err.message });
            } else {
                const responseBody = res.text ? res.text : res.body?.toString();
                this.setState({ uploadValidationMsg: responseBody });
            }
            await this.RefreshModel();

            this.setState({
                inputFileKey: new Date().toString(),
                fileTypeValid: false,
                isUploading: false,
            });
        });
    }

    private handleUploadFileChange(e) {
        if (!e.target.files) {
            return;
        }
        this.setState({ selectedFile: e.target.files[0] });
        if (e.target.files[0].name.endsWith(".csv")) {
            this.setState({ fileTypeValid: true });
        } else {
            this.setState({ fileTypeValid: false });
        }
    }

    private async RefreshModel() {
        this.setState({ isLoading: true });
        const data = await firstValueFrom(
            AdministrationService.GetVendorMeasures$(this.props.user, this.props.productYear)
        );
        this.setState({ payload: data, isLoading: false });
    }
}

const VendorMeasureGuidListPageWithState = connect<IGenericUserProps>(
    genericMapStateToProps
)(VendorMeasureGuidListView);

// STYLES CONTAINER
const VendorMeasureGuidListPage = withStyles(styles)(
    VendorMeasureGuidListPageWithState
);

export default VendorMeasureGuidListPage;

